import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "k-quick-access-card rounded-16 flex column bg-white shadow-1 q-py-md q-px-12 relative-position" }
const _hoisted_2 = { class: "flex items-center no-wrap" }
const _hoisted_3 = { class: "q-mb-none fs-13px text-cool-gray-100 fw-600" }
const _hoisted_4 = { class: "flex-1 flex column gap-sm" }

interface IProps {
  title: string
  icon: string
  hasTag?: boolean
  type?: 'beta' | 'lite' | 'pro' | 'pro_finished'
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KQuickAccessCard' },
  __name: 'KQuickAccessCard',
  props: {
    title: {},
    icon: {},
    hasTag: { type: Boolean, default: true },
    type: { default: 'lite' }
  },
  emits: ['click'],
  setup(__props: any) {







return (_ctx: any,_cache: any) => {
  const _component_KIcon = _resolveComponent("KIcon")!
  const _component_KDivider = _resolveComponent("KDivider")!
  const _component_KBtn = _resolveComponent("KBtn")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    (__props.hasTag)
      ? (_openBlock(), _createBlock(_component_KIcon, {
          key: 0,
          class: "k-quick-access-card__tag",
          name: 'tag-' + __props.type,
          size: __props.type !== 'lite' ? '46px' : '36px'
        }, null, 8, ["name", "size"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (__props.icon)
        ? (_openBlock(), _createBlock(_component_KIcon, {
            key: 0,
            name: __props.icon,
            size: "32px",
            class: "q-mr-sm"
          }, null, 8, ["name"]))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_3, _toDisplayString(__props.title), 1)
    ]),
    _createVNode(_component_KDivider, {
      class: "q-my-12",
      size: "md"
    }),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createVNode(_component_KDivider, {
      class: "q-my-12",
      size: "md"
    }),
    _createVNode(_component_KBtn, {
      class: "q-mx-auto",
      model: "secondary",
      label: __props.type !== 'pro_finished' ? 'Open' : 'Review Plan',
      size: "sm",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
    }, null, 8, ["label"])
  ]))
}
}

})